import Vue from 'vue';

Vue.config.devtools = true
const mutations = {
    setOccasion(state, payload){
        state.occasion = payload;
    },
    setAddonProducts(state, payload) {
        state.addonProducts = payload;
    },
    setAddonIds(state, payload) {
        state.addonIds = payload;
    },
    setRtsProducts(state, payload) {
        state.rtsProducts = payload;
    },
    setGocProducts(state, payload) {
        state.gocProducts = payload;
    },
    setGocImage(state,payload){
        state.gocImage = payload;
    },
    setWaysImages(state,payload){
        state.waysImages = payload;
    },
    setHeaders(state,payload){
        state.headers = payload;
    },
    setSlides(state,payload){
        state.slides = payload;
    }
};

export default mutations;
